import { DateTime } from 'luxon';

export default function formatChatHomeDateTime(datetime: string) {
  let formattedDatetime = '';

  if (datetime) {
    const current = DateTime.fromISO(datetime);
    const yesterday = DateTime.local().startOf('day').minus({ days: 1 });
    const isDatetimeYesterday = current
      .startOf('day')
      .hasSame(yesterday, 'day');

    const isDatetimeToday = DateTime.local().hasSame(current, 'day');
    const isWithinPastWeek = current > DateTime.local().minus({ days: 7 });

    if (isDatetimeYesterday) {
      formattedDatetime = 'Yesterday';
    } else if (isDatetimeToday) {
      formattedDatetime = current.toFormat('h:mm a');
    } else if (isWithinPastWeek) {
      formattedDatetime = current.toFormat('EEE');
    } else {
      formattedDatetime = current.toFormat('M/d');
    }
  }

  return formattedDatetime;
}
